import React, { useEffect, useState } from 'react';
import { Popup, Selector, Toast } from 'antd-mobile';
import axios from 'axios';
import API_ROUTES from '../../api';

const IDENTITY_OPTIONS = [
    { label: '上场队员', value: 0 },
    { label: '主裁', value: 1 },
    { label: '边裁', value: 2 },
    { label: 'VAR', value: 3 },
    { label: '观众', value: 4 },
];

// 到场确认、鸽子标记和位置调整集中在同一个底部面板中完成。
const AttendanceManagePopup = ({ visible, user, avatar, gameDetail, teams, positions, onClose, onUpdated }) => {
    const [attendance, setAttendance] = useState('arrived');
    const [identity, setIdentity] = useState(0);
    const [team, setTeam] = useState(null);
    const [position, setPosition] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (!user) return;
        setAttendance('arrived');
        setIdentity([0, 1, 2, 3, 4].includes(user.gameType) ? user.gameType : 0);
        setTeam(user.gameTeam || null);
        setPosition(user.gameRole && user.gameRole !== 12 ? user.gameRole : null);
    }, [user]);

    const submit = async () => {
        if (!user) return;
        if (attendance === 'arrived' && identity === 0 && (!team || !position)) {
            Toast.show({ content: '请选择队伍和场上位置', icon: 'fail' });
            return;
        }

        setSubmitting(true);
        try {
            const data = attendance === 'absent'
                ? { gameId: gameDetail.id, userId: user.id, arrive: 2 }
                : {
                    gameId: gameDetail.id,
                    userId: user.id,
                    team: identity === 0 ? team : null,
                    position: identity === 0 ? position : null,
                    referee: identity === 0 ? null : identity,
                };
            await axios.post(API_ROUTES.game_changePosition, data, {});
            Toast.show({
                content: attendance === 'absent' ? '已标记为鸽子' : '到场状态已更新',
                icon: 'success',
            });
            onClose();
            onUpdated();
        } catch (error) {
            Toast.show({ content: '操作失败，请重试', icon: 'fail' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Popup
            visible={visible}
            onMaskClick={onClose}
            bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, maxHeight: '88vh', overflow: 'hidden' }}
            style={{ '--z-index': 1250 }}
        >
            <div className="attendance-sheet">
                <div className="attendance-sheet-header">
                    <button type="button" onClick={onClose}>取消</button>
                    <div>
                        <div className="attendance-sheet-title">到场与位置</div>
                        <div className="attendance-sheet-subtitle">确认人员状态并调整本场身份</div>
                    </div>
                    <button type="button" className="primary" disabled={submitting} onClick={submit}>确认</button>
                </div>

                <div className="attendance-sheet-content">
                    <div className="attendance-person-card">
                        <img src={avatar} alt={user?.name || ''} />
                        <div>
                            <strong>{user?.name}</strong>
                            <span>当前：{user?.gameType === 0 ? '上场队员' : (IDENTITY_OPTIONS.find(item => item.value === user?.gameType)?.label || '未设置')}</span>
                        </div>
                    </div>

                    <div className="attendance-status-grid">
                        <button type="button" className={attendance === 'arrived' ? 'arrived active' : 'arrived'} onClick={() => setAttendance('arrived')}>
                            <b>✓</b><span>确认到场</span><em>可调整身份和位置</em>
                        </button>
                        <button type="button" className={attendance === 'absent' ? 'absent active' : 'absent'} onClick={() => setAttendance('absent')}>
                            <b>🕊</b><span>未到场</span><em>移入鸽子名单</em>
                        </button>
                    </div>

                    {attendance === 'arrived' && (
                        <div className="attendance-settings">
                            <div className="attendance-section-title">本场身份</div>
                            <Selector columns={3} options={IDENTITY_OPTIONS} value={[identity]} onChange={value => setIdentity(value[0] ?? 0)} />

                            {identity === 0 && (
                                <>
                                    <div className="attendance-section-title">所属队伍</div>
                                    <Selector columns={2} options={teams} value={team ? [team] : []} onChange={value => setTeam(value[0] || null)} />
                                    <div className="attendance-section-title">场上位置</div>
                                    <Selector columns={3} options={positions} value={position ? [position] : []} onChange={value => setPosition(value[0] || null)} />
                                </>
                            )}
                        </div>
                    )}

                    {attendance === 'absent' && (
                        <div className="attendance-absent-tip">确认后将记录为未到场，并移入鸽子名单。</div>
                    )}
                </div>
            </div>
        </Popup>
    );
};

export default AttendanceManagePopup;
